__webpack_require__.p = "/ux/assets/";